import classNames from 'classnames';

type Props = {
    codeValue: string;
    errorValue: string;
    redesign?: boolean;
    setCodeValue: (a: string) => void;
    shouldDisplayErrors?: boolean;
};

const PersonalCodeInput = ({
    codeValue,
    errorValue,
    redesign,
    setCodeValue,
    shouldDisplayErrors,
}: Props) => {
    const id = 'personalCode';

    return (
        <div
            className={classNames(
                'flex flex-col mb-4 md:mb-0',
                redesign ? 'mr-2 md:mr-3 lg:mr-4 w-1/2' : 'md:mr-4'
            )}
        >
            <label htmlFor={id} className="text-base">
                PlanMatch Code
            </label>
            <input
                className={classNames(
                    'w-full p-3 rounded placeholder-gray text-black',
                    redesign ? 'xl:w-32' : 'md:w-32',
                    shouldDisplayErrors
                        ? 'border-2 border-red bg-red-lightest'
                        : 'border border-gray'
                )}
                id={id}
                data-qa="code"
                type="text"
                maxLength={6}
                aria-required="true"
                value={codeValue}
                onChange={(e) => setCodeValue(e.target.value)}
            />
            <div
                className={classNames(
                    'flex items-center md:items-start mt-1 text-sm text-red',
                    !shouldDisplayErrors && !errorValue && 'hidden'
                )}
                aria-live="polite"
            >
                <i className="icon-error h-4 w-4 mr-1 md:mt-1" data-qa="error-code-icon"></i>
                <span
                    className={`${id}-error-text inline-block md:max-w-[105px]`}
                    data-qa="error-code"
                >
                    {errorValue}
                </span>
            </div>
        </div>
    );
};

export default PersonalCodeInput;
